/*
NOTE: this file only temporarily resides in scratch-gui.
Nearly identical code appears in scratch-www, and the two should
eventually be consolidated.
*/

// import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React, {useState, useRef, useEffect, useCallback, Dispatch, SetStateAction, useContext} from 'react';

// import MenuBarMenu from './menu-bar-menu.jsx';
// import {MenuSection} from '../menu/menu.jsx';
// import MenuItemContainer from '../../containers/menu-item.jsx';
import UserAvatar from './user-avatar.jsx';
import dropdownCaret from './dropdown-caret.svg';
import profileIcon from './icon--profile.png';
import './account-nav.css';
import LoginModal from '../login/login.jsx';
import MyProjectModal from '../myWork/index.jsx'
import AccountManagementModal from '../account-management/account-management.jsx';
import { useSelector, useDispatch } from 'react-redux'
import { setUserLoginState } from '../store/user-state'
import { RootState } from '../store/modalStore'
import { useSelection } from "../workbench/use-selection";
import { setMataProjectId, setProjectTitle, setProjectTitleold } from '../store/project-state';
import { SyncStatus } from '../device/device-hooks';
import { FileSystem, VersionAction } from "../fs/fs";
import { createHost } from "../fs/host";
import { deployment } from "../deployment";
import { fetchMicroPython } from "../micropython/micropython";



type UseSyncStatus = [SyncStatus, Dispatch<SetStateAction<SyncStatus>>];

const SyncContext = React.createContext<undefined | UseSyncStatus>(undefined);

export const useSyncStatus = (): SyncStatus => {
  const value = useContext(SyncContext);
  if (!value) {
    throw new Error("Missing provider!");
  }
  return value[0];
};

const AccountNavComponent = ({
    username,
    fs
}) => {
    const syncStatusState = useState<SyncStatus>(SyncStatus.OUT_OF_SYNC);
    const [, setSyncStatus] = syncStatusState;
    const [, setSelection] = useSelection();
    useEffect(() => {
        // 请求原生fs等方法接口
        const logging = deployment.logging;
        const host = createHost(logging);
        const fss = new FileSystem(logging, host, fetchMicroPython);

        // 如果是点入我的作品刷新后首先展示是我的作品内容
        // console.log(localStorage.getItem('projectTitle'), 'ProjectTitleProjectTitle')
        let file = localStorage.getItem('projectTitle') || 'main.py'

        //pyName与projectTitle保持一致
        if(file.endsWith('.py')){
            localStorage.setItem('pyName', file.replace('.py', ''))
        } else {
            localStorage.setItem('pyName', file)
        }
        const fileId = localStorage.getItem('projectId')
        dispatch(setProjectTitle(file))
        dispatch(setProjectTitleold(file))
        dispatch(setMataProjectId(fileId))

        const y = fs['fs']['fs'];
        if (y && y.project && y.project.files.length <= 0) {
            file = 'main.py'
            dispatch(setProjectTitle('main.py'))
            dispatch(setProjectTitleold('main.py'))
            dispatch(setMataProjectId(null))
            fss.write(
                file,
                '',
                VersionAction.INCREMENT
            );
            localStorage.removeItem('projectTitle')
            localStorage.removeItem('projectId')
            location.reload()
        }
        setSelection({ file, location: { line: undefined } });
        // 在组件挂载时添加点击事件监听
        document.addEventListener('click', handleClickOutside);
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    const loginStateStore = useSelector((state: RootState) => state.userStore.loginState);
    // 我的下拉框展示状态
    const [bulletState, setBulletState] = useState<boolean>(false);
    // 获取登录状态
    const [loginState, setLoginState] = useState<string>(localStorage.getItem('token'));
    // 打开登录弹框
    const [showLoginVisible, setShowLoginVisible] = useState<boolean>(false);
    // 打开我的作品弹框
    const [showMyworkVisible, setShowMyworkVisible] = useState<boolean>(false);
    // 打开账户管理弹框
    const [showAccountManageVisible, setShowAccountManageVisible] = useState<boolean>(false);
    const accountRef = useRef<HTMLDivElement>(null);
    // 点击其它地方下拉框消失
    const handleClickOutside: EventListener = (event: Event) => {
        if (accountRef.current && !accountRef.current.contains(event.target as Node)) {
          // 点击了除了<div>以外的其他地方
          setBulletState(false);
          // 执行关闭<div>的操作
        }
    };
    

    
    const handleOpenlogin = (status) => {
        setBulletState(!status)
    };
    const handleOpenNewWorks = (type) => {
        if (type === 'out') {
            localStorage.removeItem('token');
            setLoginState(localStorage.getItem('token'))
            dispatch(setUserLoginState(''))
        } else if (type === 'myWork') {
            setShowMyworkVisible(true)
        } else {
            setShowAccountManageVisible(true)
        }
    }
    // 打开登录弹框
    const handleLoginDia = () => {
        setShowLoginVisible(true)
    }
    // 关闭登录弹框
    const handleLoginDiaClose = () => {
        setShowLoginVisible(false)
    }
    // 登录成功后
    const dispatch = useDispatch()
    const handleLoginSuccess = () => {
        setLoginState(localStorage.getItem('token'))
        dispatch(setUserLoginState(localStorage.getItem('token')))
    }
    // 关闭我的作品弹框
    const handleMyworkDiaClose = () => {
        setShowMyworkVisible(false)
    }
    // 关闭账户管理弹框
    const handleAccountManageClose = () => {
        setShowAccountManageVisible(false)
    }
    const titleOld = useSelector((state: RootState) => state.projectStore.titleOld)
    // 打开我的作品
    const setSelectedFile = useCallback(
        (file: string, fs) => {
            // file = titleOld ? titleOld : file
            setSelection({ file, location: { line: undefined } });
        },
        [setSelection]
    );
    
    return (
        <React.Fragment>
            {
                loginState || loginStateStore ? 
                <div
                    ref={accountRef}
                    className="userInfo"
                    onClick={() => handleOpenlogin(bulletState)}
                >
                    <UserAvatar
                        className="avatar"
                        imageUrl={profileIcon}
                    />
                    <span className="profileName">
                        {username}
                    </span>
                    <div className="dropdownCaretPosition">
                        <img
                            className="dropdownCaretIcon"
                            src={dropdownCaret}
                        />
                    </div>
                </div> : <div
                    ref={accountRef}
                    className="userInfo"
                    onClick={() => handleLoginDia()}
                >
                    <UserAvatar
                        className="avatar"
                        imageUrl={profileIcon}
                    />
                    <div className="profileName">
                        <span className="dropdownCaretIcon">
                            {/* 登录 */}
                            <FormattedMessage
                                defaultMessage="Sign in"
                                id="meun-item-account-login"
                            />
                        </span>
                    </div>
                </div>
            }
            

            {bulletState && 
                <div 
                    className="languageMenuContainer"
                    style={{width:'100px'}}
                >
                    <div
                        className="languageMenuItem"
                        onClick={() => handleOpenNewWorks('myWork')}
                    >
                        <div className="line"></div>
                        {/* 我的作品 */}
                        <FormattedMessage
                            defaultMessage="My Projects"
                            id="meun-item-account-mywork"
                        />
                    </div>
                    <div
                        className="languageMenuItem"
                        onClick={() => handleOpenNewWorks('account')}
                    >
                        <div className="line"></div>
                        {/* 账户管理 */}
                        <FormattedMessage
                            defaultMessage="Account Management"
                            id="meun-item-account-accountManagement"
                        />
                    </div>
                    <div
                        className="languageMenuItem"
                        onClick={() => handleOpenNewWorks('out')}
                    >
                        <div className="line"></div>
                        {/* 登出 */}
                        <FormattedMessage
                            defaultMessage="Sign out"
                            id="meun-item-account-signOut"
                        />
                    </div>
                </div>
            }

            {/* 打开登录弹框 */}
            {showLoginVisible ? (
                <LoginModal 
                    onCancel={handleLoginDiaClose}
                    onSuccessFunc={handleLoginSuccess}
                />
            ) : null}
            {/* 我的作品弹框 */}
            {showMyworkVisible ? (
                <MyProjectModal 
                    onCancel={handleMyworkDiaClose}
                    fs={fs}
                    onSetSelection={setSelectedFile}
                />
            ) : null}
            {/* 账户管理弹框 */}
            {showAccountManageVisible ? (
                <AccountManagementModal
                    onRequestClose={handleAccountManageClose}
                />
            ) : null}

            {/* <MenuBarMenu
                className={menuBarMenuClassName}
                open={isOpen}
                // note: the Rtl styles are switched here, because this menu is justified
                // opposite all the others
                place={isRtl ? 'right' : 'left'}
                onRequestClose={onClose}
            >
                <MenuItemContainer href={profileUrl}>
                    <FormattedMessage
                        defaultMessage="Profile"
                        description="Text to link to my user profile, in the account navigation menu"
                        id="gui.accountMenu.profile"
                    />
                </MenuItemContainer>
                <MenuItemContainer href="/mystuff/">
                    <FormattedMessage
                        defaultMessage="My Stuff"
                        description="Text to link to list of my projects, in the account navigation menu"
                        id="gui.accountMenu.myStuff"
                    />
                </MenuItemContainer>
                {isEducator ? (
                    <MenuItemContainer href="/educators/classes/">
                        <FormattedMessage
                            defaultMessage="My Classes"
                            description="Text to link to my classes (if I am a teacher), in the account navigation menu"
                            id="gui.accountMenu.myClasses"
                        />
                    </MenuItemContainer>
                ) : null}
                {isStudent ? (
                    <MenuItemContainer href={`/classes/${classroomId}/`}>
                        <FormattedMessage
                            defaultMessage="My Class"
                            description="Text to link to my class (if I am a student), in the account navigation menu"
                            id="gui.accountMenu.myClass"
                        />
                    </MenuItemContainer>
                ) : null}
                <MenuItemContainer href="/accounts/settings/">
                    <FormattedMessage
                        defaultMessage="Account settings"
                        description="Text to link to my account settings, in the account navigation menu"
                        id="gui.accountMenu.accountSettings"
                    />
                </MenuItemContainer>
                <MenuSection>
                    <MenuItemContainer onClick={onLogOut}>
                        <FormattedMessage
                            defaultMessage="Sign out"
                            description="Text to link to sign out, in the account navigation menu"
                            id="gui.accountMenu.signOut"
                        />
                    </MenuItemContainer>
                </MenuSection>
            </MenuBarMenu> */}
        </React.Fragment>
    )
};

AccountNavComponent.propTypes = {
    className: PropTypes.string,
    classroomId: PropTypes.string,
    isEducator: PropTypes.bool,
    isOpen: PropTypes.bool,
    isRtl: PropTypes.bool,
    isStudent: PropTypes.bool,
    menuBarMenuClassName: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    onLogOut: PropTypes.func,
    profileUrl: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    username: PropTypes.string,
    fs: PropTypes.object
};

export default AccountNavComponent;
